import { differenceInSeconds } from 'date-fns';

/**
 * 주어진 cutoff_time(정수, 시 단위)에 대해
 * 현재 시각까지 남은 시간을 HH:mm:ss 형식으로 반환.
 * 이미 시간이 지났다면 null 반환.
 */
export const getFormattedRemainingCutoffTime = (cutoffTimeDate: Date): string => {
  const diffInSeconds = differenceInSeconds(cutoffTimeDate, new Date());

  const hours = Math.floor(diffInSeconds / 3600);
  const minutes = Math.floor((diffInSeconds % 3600) / 60);
  const seconds = diffInSeconds % 60;

  return [
    hours.toString().padStart(2, '0'),
    minutes.toString().padStart(2, '0'),
    seconds.toString().padStart(2, '0'),
  ].join(':');
};
